import { useState } from "react";
import { ListOrdered, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";
import { RoutineListContent } from "./routine-list/RoutineListContent";
import { SequentialOrderDialog } from "./SequentialOrderDialog";
import { PlanMode } from "../hooks/usePlanMode";

interface WorkoutPlanContentProps {
  routines: any[];
  onRoutinesChange: () => void;
  onRemoveRoutine: (routineId: string) => Promise<void>;
  showRemoveButton: boolean;
  planId: string;
  isPersonalPlan: boolean;
  canEdit: boolean;
  updateCounter: number;
  mode: PlanMode;
  onSequentialChange: () => void;
}

export const WorkoutPlanContent = ({
  routines,
  onRoutinesChange,
  onRemoveRoutine,
  showRemoveButton,
  planId,
  isPersonalPlan,
  canEdit,
  mode,
  onSequentialChange,
}: WorkoutPlanContentProps) => {
  const [reorderOpen, setReorderOpen] = useState(false);
  const isSequential = mode === "sequential";

  return (
    <div className="space-y-3">
      {isSequential && (
        <div className="flex items-center justify-between gap-3 rounded-xl border border-primary/30 bg-primary/5 px-4 py-3">
          <div className="flex items-center gap-2 text-sm text-primary">
            <ListOrdered className="h-4 w-4" />
            <span className="font-medium">Modo secuencial activo</span>
            <span className="hidden sm:inline text-primary/60">
              · Las rutinas se entrenan en orden
            </span>
          </div>
          {canEdit && (
            <Button
              variant="outline"
              size="sm"
              onClick={() => setReorderOpen(true)}
              className="h-8"
            >
              <Pencil className="mr-1.5 h-3.5 w-3.5" />
              Cambiar orden
            </Button>
          )}
        </div>
      )}

      <RoutineListContent
        routines={routines}
        onRoutinesChange={onRoutinesChange}
        onRemoveRoutine={onRemoveRoutine}
        showRemoveButton={showRemoveButton}
        planId={planId}
        isPersonalPlan={isPersonalPlan}
        canEdit={canEdit}
        hideDaySelector={isSequential}
      />

      {isSequential && (
        <SequentialOrderDialog
          open={reorderOpen}
          onOpenChange={setReorderOpen}
          routines={routines}
          planId={planId}
          onConfirmed={onSequentialChange}
        />
      )}
    </div>
  );
};

